export default [
  {
    path: '/online-store/onboarding',
    name: 'online-store-onboarding',
    component: () => import('@/views/pages/komstore/onboarding/OnboardingPage.vue'),
    meta: {
      resource: 'Komstore Partner Onboarding',
      action: 'manage',
    },
  },
  {
    path: '/komstore',
    name: 'komstore',
    component: () => import('@/views/pages/komstore/onboarding/OnboardingPage.vue'), // Dummy component for V1, V2 will take over
    meta: {
      resource: 'Komstore',
      action: 'manage',
    },
  },
  {
    path: '/online-store/design',
    name: 'online-store-design',
    component: () => import('@/views/pages/komstore/EmbedDesainWebsite.vue'), 
    meta: {
      resource: 'Toko Online',
      action: 'manage',
      pageTitle: 'Desain Website',
      breadcrumb: [
        {
          text: 'Toko Online',
        },
        {
          text: 'Desain Website',
          active: true,
        },
      ],
    },
  },
  {
    path: '/online-store/editor/:id',
    name: 'online-store-editor',
    component: () => import('@/views/pages/komstore/EmbedEditor.vue'), 
    meta: {
      layout: 'full',
      resource: 'Toko Online',
      action: 'manage',
      pageTitle: 'Template Editor',
    },
  },
  {
    path: '/online-store/management',
    name: 'online-store-management',
    component: () => import('@/views/pages/komstore/EmbedManajemenToko.vue'), 
    meta: {
      resource: 'MyApps',
      action: 'manage',
    },
  },
  {
    path: '/online-store/domain-seo',
    name: 'online-store-domain-seo',
    component: () => import('@/views/pages/komstore/onboarding/OnboardingPage.vue'), 
    meta: {
      resource: 'Komstore',
      action: 'manage',
    },
  },
]
